import { KneeVariabilityData_FunctionalMovement } from '@/models/reportV2.model';

import { themeColors } from '@/theme/colors';

import { flattenData, toGraphData, toVariabilityData } from '.';

/**
 * Retrieves knee variability data based on the provided parameters.
 *
 * @param data - The data object containing the knee variability data.
 * @param side - The side of the knee ('Left' or 'Right').
 * @returns The knee variability data.
 */
export function getKneeVariabilityData_FunctionalMovement(
  data: any,
  side: 'Left' | 'Right',
): KneeVariabilityData_FunctionalMovement {
  const overviewColor = side === 'Left' ? themeColors.variabilityAll_Left : themeColors.variabilityAll_Right;
  const crpDataThighCalf = toGraphData(data[`crpKnee${side}`][`crpThighCalf_${side}`]);
  const crpSeriesDataThighCalf = [
    {
      type: 'line',
      name: 'Thigh (s) / Calf (s)',
      data: flattenData(crpDataThighCalf),
      color: themeColors.colorSS,
    },
  ];

  const crpDataThighCalfT = toGraphData(data[`crpKnee${side}`][`crpThighCalfT_${side}`]);
  const crpSeriesDataThighCalfT = [
    {
      type: 'line',
      name: 'Thigh (s) / Calf (t)',
      data: flattenData(crpDataThighCalfT),
      color: themeColors.colorST,
    },
  ];

  const crpDataThighCCalfT = toGraphData(data[`crpKnee${side}`][`crpThighCCalfT_${side}`]);
  const crpSeriesDataThighCCalfT = [
    {
      type: 'line',
      name: 'Thigh (c) / Calf (t)',
      data: flattenData(crpDataThighCCalfT),
      color: themeColors.colorCT,
    },
  ];

  const coordinativeVariabilityDataAllKnee = toVariabilityData(
    data.coordinativeVariability[`coordinativeVariabilityDataKnee_${side}`].col0,
  );
  const coordinativeVariabilitySeriesAllKnee = [
    {
      type: 'area',
      name: 'All planes',
      data: coordinativeVariabilityDataAllKnee,
      color: overviewColor,
    },
  ];

  const coordinativeVariabilityDataThighCalf = toVariabilityData(
    data.coordinativeVariabilitySquat[`coordinativeVariabilityThighCalf_${side}`].col0,
  );
  const coordinativeVariabilitySeriesThighCalf = [
    {
      type: 'area',
      name: 'Thigh (s) / Calf (s)',
      data: coordinativeVariabilityDataThighCalf,
      color: themeColors.colorSS,
    },
  ];

  const coordinativeVariabilityDataThighCalfT = toVariabilityData(
    data.coordinativeVariabilitySquat[`coordinativeVariabilityThighCalf_${side}`].col1,
  );
  const coordinativeVariabilitySeriesThighCalfT = [
    {
      type: 'area',
      name: 'Thigh (s) / Calf (t)',
      data: coordinativeVariabilityDataThighCalfT,
      color: themeColors.colorST,
    },
  ];

  const coordinativeVariabilityDataThighCCalfT = toVariabilityData(
    data.coordinativeVariabilitySquat[`coordinativeVariabilityThighCalf_${side}`].col2,
  );
  const coordinativeVariabilitySeriesThighCCalfT = [
    {
      type: 'area',
      name: 'Thigh (c) / Calf (t)',
      data: coordinativeVariabilityDataThighCCalfT,
      color: themeColors.colorCT,
    },
  ];

  return {
    crpSeriesDataThighCalfT,
    crpSeriesDataThighCCalfT,
    crpSeriesDataThighCalf,
    coordinativeVariabilitySeriesAllKnee,
    coordinativeVariabilitySeriesThighCalf,
    coordinativeVariabilitySeriesThighCalfT,
    coordinativeVariabilitySeriesThighCCalfT,
  };
}
